import { render, staticRenderFns } from "./IntroRichModule.vue?vue&type=template&id=5ce28d50&"
import script from "./IntroRichModule.ts?vue&type=script&lang=ts&"
export * from "./IntroRichModule.ts?vue&type=script&lang=ts&"
import style0 from "./IntroRichModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports